import { render, staticRenderFns } from "./myPagination.vue?vue&type=template&id=7da7e1bd&scoped=true"
import script from "./myPagination.vue?vue&type=script&lang=js"
export * from "./myPagination.vue?vue&type=script&lang=js"
import style0 from "./myPagination.vue?vue&type=style&index=0&id=7da7e1bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da7e1bd",
  null
  
)

export default component.exports